export const FETCH_PHOTOS= 'FETCH_PHOTOS';
export const FETCH_POSTS= 'FETCH_POSTS';
export const SINGLE_POST= 'SINGLE_POST';
